import type { AvailableSite } from '@atlassian/gic-anywhere';

import { useGetAvailableSitesForSingleIssueCreateForm } from './useGetAvailableSitesForSingleIssueCreateForm';

export type SingleIssueCreateInitialData = {
	availableSites: AvailableSite[];
	isLoading: boolean;
	error: Error | null;
};

export const useGetInitialDataForSingleIssueCreateForm = (): SingleIssueCreateInitialData => {
	const availableSitesResult = useGetAvailableSitesForSingleIssueCreateForm();
	const {
		availableSites,
		isLoading: isSiteLoading,
		error: sitesError,
	} = availableSitesResult ?? { availableSites: [], isLoading: false, error: null };
	const isLoading = isSiteLoading ?? false;
	const error = sitesError ?? null;

	const singleIssueCreateInitialData: SingleIssueCreateInitialData = {
		availableSites,
		isLoading,
		error,
	};

	return singleIssueCreateInitialData;
};
